import clsx from 'clsx';
import type { PropsWithChildren } from 'react';

type MenuItemLabelProps = PropsWithChildren<{
  className?: string;
}>;

export const MenuItemLabel = ( { className, children }: MenuItemLabelProps ) => {
  return (
    <p className={ clsx(
      'text-xs leading-[15px]',
      className
    ) }>{ children }</p>
  )
}
MenuItemLabel.displayName = 'MenuItemLabel';
